<!-- @format -->

<template>
	<!-- 授权用户 -->
	<el-dialog
		v-model="visible"
		:close-on-click-modal="false"
		:title="'系统风格'"
		append-to-body
		custom-class="theme-dialog"
		@close="hide"
	>
		<el-radio-group v-model="radioChecked" class="">
			<div :gutter="10" class="theme-all">
				<div :span="12" class="theme-item theme-blue" @click="onClickTheme('blue')">
					<el-radio label="blue" size="large" class="radio-right-top"> &nbsp; </el-radio>
				</div>
				<div :span="12" class="theme-item theme-white" @click="onClickTheme('white')">
					<el-radio label="white" size="large" class="radio-right-top"> &nbsp; </el-radio>
				</div>
			</div>
		</el-radio-group>
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="hide">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script setup name="PcpThemeDialog">
	import { updateThemeStyle } from '@power/runtime-vue3';
	import { setDocumentTheme, Storage } from '@power/utils';

	const visible = ref(false);
	const radioChecked = ref('blue');

	const onClickTheme = (theme) => {
		radioChecked.value = theme;
	};

	// 显示弹框
	function show() {
		visible.value = true;
	}

	// 隐藏弹框
	function hide() {
		visible.value = false;
		initRadioChecked();
	}

	// 初始化默认选中的主题
	function initRadioChecked() {
		const themeStyle = Storage.get('themeStyle', 'blue');
		radioChecked.value = themeStyle;
	}

	initRadioChecked();

	// 提交表单
	async function submitForm() {
		const themeStyle = radioChecked.value;
		setDocumentTheme(themeStyle);
		Storage.set('themeStyle', themeStyle);

		const params = {
			themeStyle,
		};
		updateThemeStyle(params);
		hide();
	}

	defineExpose({
		show,
	});
</script>

<style lang="scss">
	// 全局大弹窗
	.theme-dialog {
		width: 45%;

		.el-radio-group {
			width: 100%;
		}

		img {
			width: 100%;
		}

		.theme-all {
			display: flex;
			width: 100%;
		}

		.radio-right-top {
			position: absolute;
			right: 0px;
			top: 0px;
		}

		.theme-item {
			position: relative;
			flex: 1;
			height: 179px;
			margin: 4px;
		}

		.theme-blue {
			background: url('@/assets/images/themeBlue.png') no-repeat center;
			background-size: cover;
		}

		.theme-white {
			background: url('@/assets/images/themeWhite.png') no-repeat center;
			background-size: cover;
		}
	}
</style>
